<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">活动类型</span>
    </div>

    <el-button class="mwow-button-filled success add" @click="handleAdd">
      新增
    </el-button>
    <el-form class="mwow-wrap form" size="mini">
      <el-row>
        <el-col :span="8">
          <el-form-item label="活动类型:" prop="title">
            <el-input
              v-model="searchInfo.title"
              placeholder="请输入活动类型"
              clearable
              @change="handleSearch"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table
      size="mini"
      :data="tableData"
      stripe
      ref="tableRef"
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
    >
      <el-table-column label="序号" type="index" width="70"> </el-table-column>
      <el-table-column label="活动类型" prop="title"> </el-table-column>
      <el-table-column label="创建时间" prop="create_time"> </el-table-column>
      <el-table-column label="创建人" prop="staff.name"> </el-table-column>
      <el-table-column label="排序" prop="sort"> </el-table-column>
      <el-table-column label="操作" prop="opreation" width="350">
        <template slot-scope="scope">
          <div class="btns">
            <el-button class="mwow-button success" @click="handleEdit(scope)"
              >编辑</el-button
            >
            <el-button class="mwow-button info" @click="handleDel(scope)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>

    <el-dialog
      destroy-on-close
      :visible.sync="activityTypeDialog"
      :title="`${activityTypeData.type_id ? '编辑' : '新增'}活动类型`"
      width="720px"
      class="activity-type"
    >
      <el-form
        size="medium"
        :model="activityTypeData"
        :rules="activityTypeRules"
        ref="activityTypeForm"
        inline
      >
        <el-form-item label="活动类型:" prop="title">
          <el-input
            placeholder="请输入活动类型名称"
            maxlength="16"
            v-model="activityTypeData.title"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="排序:" prop="sort">
          <el-input
            v-model.number="activityTypeData.sort"
            placeholder="请输入排序，序号越大排在越前面"
            clearable
            oninput="if(value.length>9)value=value.slice(0,9)"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <div class="operation">
            <el-button
              class="mwow-button-filled"
              @click="hideActivityTypeDialog"
              >取消</el-button
            >
            <el-button
              class="mwow-button-filled success"
              type="success"
              @click="handleSubmit"
              >提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getActivityTypeListApi,
  addActivityTypeApi,
  editActivityTypeApi,
  delActivityTypeApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";

export default {
  name: "activitytype",
  data() {
    return {
      searchInfo: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      activityTypeDialog: false,
      activityTypeData: {},
      activityTypeRules: {
        title: [
          {
            required: true,
            message: "活动类型不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.type) {
        params.type = this.searchInfo.type;
      }
      if (this.searchInfo.title) {
        params.title = this.searchInfo.title;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getActivityTypeListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              item.create_time * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 新增
    handleAdd() {
      this.activityTypeData = {
        title: "",
        sort: "",
      };
      this.activityTypeDialog = true;
    },
    // 编辑
    handleEdit(scope) {
      this.activityTypeData = {
        type_id: scope.row.type_id,
        title: scope.row.title,
        sort: scope.row.sort || 0,
      };
      this.activityTypeDialog = true;
    },
    hideActivityTypeDialog() {
      this.activityTypeDialog = false;
    },
    // 提交
    handleSubmit() {
      if (this.activityTypeData.type_id) {
        if (!this.activityTypeData.sort) this.activityTypeData.sort = 0;
        editActivityTypeApi(this.activityTypeData).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.getList();
            this.hideActivityTypeDialog();
          } else {
            return this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      } else {
        if (!this.activityTypeData.sort) this.activityTypeData.sort = 0;
        addActivityTypeApi(this.activityTypeData).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.getList();
            this.hideActivityTypeDialog();
          } else {
            return this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      }
    },
    // 删除
    handleDel(scope) {
      this.$confirm(
        `确定对${scope.row.title}的活动类型进行删除么？`,
        `删除-${scope.row.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          delActivityTypeApi({
            type_id: scope.row.type_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
}
/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 100px !important;
    }
    .el-form-item__content {
      width: 100%;
      div:nth-child(1) {
        width: 90%;
      }
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}

.add {
  margin: 0 0 20px 10px;
}
/deep/.activity-type {
  .el-dialog__body {
    padding: 20px 20px 0px 20px !important;
    .el-form {
      display: flex;
      flex-direction: column;
      .el-form-item {
        margin: 0 0 10px 0;
      }
      .el-form-item__label {
        min-width: 80px;
      }
      .el-form-item__content {
        line-height: 0px;
        width: 80%;
        margin-bottom: 10px;
        div:nth-child(1) {
          width: 100%;
        }
      }
      .el-select {
        width: 100% !important;
      }
      .operation {
        padding-left: 80px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
